import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import UseDevicePixelRatio from '../../../../common/hooks/useDevicePixelRatio'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { panelTypes } from '../../../../common/panel/constants'
import classes from './index.module.scss'
import {
  changeActivePanel,
  removePanel,
  selectActivePanel,
  selectDetailPanel,
} from './store/slice'

const getItemId = (id) => `item_${id}`

export const decodeItemId = (id) => id.split('_')[1]

let imageDragEl = null

const LayoutItem = ({ id }) => {
  const dispatch = useDispatch()

  const devicePixelRatio = UseDevicePixelRatio()
  const panel = useSelector(selectDetailPanel(id))
  const activePanel = useSelector(selectActivePanel)

  const [isHover, setIsHover] = useState(false)

  const onDragOver = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const onDragStart = (e) => {
    const dragEl = e.target.cloneNode(true)
    dragEl.style.width = panel.type === panelTypes.HALF_SIZE ? '175px' : '350px'
    dragEl.style.display = 'flex'
    imageDragEl = dragEl
    document.body.appendChild(dragEl)
    e.dataTransfer.setDragImage(
      dragEl,
      e.target.offsetWidth / devicePixelRatio / 2,
      20 / devicePixelRatio,
    )
    e.dataTransfer.setData('childId', getItemId(id))
  }

  const onDragEnd = () => {
    if (imageDragEl) {
      document.body.removeChild(imageDragEl)
    }
    imageDragEl = null
    setIsHover(false)
  }

  const removeItem = (e) => {
    e.stopPropagation()
    if (isActive) {
      dispatch(changeActivePanel(null))
    }
    dispatch(removePanel(id))
  }

  const setActivePanel = () => dispatch(changeActivePanel(id))

  const isActive = id === activePanel

  return (
    <Element
      id={getItemId(id)}
      style={{
        width: panel.type === panelTypes.HALF_SIZE ? `calc(50% - 2px)` : '100%',
        border: isActive ? '1px solid #2C73E8' : '1px solid #D5D5D5',
        backgroundColor: isActive ? '#C8E3FF' : isHover ? '#EDF5FE' : 'unset',
      }}
      className={classes.layoutItem}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      onClick={setActivePanel}
      draggable={true}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDragEnd={onDragEnd}
    >
      <Icon
        className="icon-drag"
        style={{ color: isActive ? '#2C73E8' : '#9C9C9C' }}
      />
      <div className={`flex1 ${classes.ml5}`}>
        <Translate value={panel.label} />
      </div>
      <Icon
        onClick={removeItem}
        className="icon-delete"
        style={{ color: '#9C9C9C', fontSize: 11, opacity: isHover ? 1 : 0 }}
      />
    </Element>
  )
}

export default LayoutItem
